import {Box, styled, Stack} from '@mui/material';

const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 60px;
	}
`;

const StyledStack = styled(Stack)`
	width: 100%;
	align-items: center;
	justify-content: end;
	gap: 8px;
	margin-top: 0px;
	flex-direction: row;

	${({theme}) => theme.breakpoints.down('sm')} {
		margin-top: 8px;
		flex-direction: column;
	}
`;

export {StyledStack, StyledBox};
